import React from 'react';
import { FaFacebook} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const MainContent = () => {
  const TruthSocialIcon = () => (
    <img src="/TS-logomark-KO.svg" alt="Truth Social Logo" width={24} height={24} />
  );
  return (
    <div className="content">
      <div className="header">
        <span>"Government's first duty is to protect the people, not run their lives." – President Ronald Reagan</span>
      </div>

      <div className="top-section">
        <div className="mainImage">
          <img src="/poteetlogo.png" alt="Main logo for Bill Poteet for State Representative District 82" />
        </div>
        <div className="profileImage">
          <img src="/bill_poteet_silhouette.png" alt="Profile shot of Bill Poteet" />
        </div>
      </div>

      <div className="content-snippet">Proven Conservative Leader</div> 

      <div className="donate-link">
        <a href="https://secure.anedot.com/bill-poteet-for-state-representative-dist-82/donate">DONATE</a>
      </div>

      <div className="platform">
        <h3>Why Bill?</h3>

        <div className='introduction'>
          Bill strongly supports President Trump and Governor DeSantis immigration policies. He knows we need to root out government waste, reduce unnecessary and costly regulations, lower our taxes, protect private property rights, fight for lower insurance costs, and ensure the safety of our neighborhoods. With a servant's heart, Bill's life has been dedicated to giving back to the community through active involvement in civic, educational, professional, and political initiatives.
        </div>
        <div className='imageContainer'>
            <img src="/bill_poteet_water.JPG" alt="Bill Poteet by the water." />
        </div>

        <div className='introduction'>
        For over 50 years, Bill Poteet has been a Collier County resident. Bill grew up in Missouri
        and moved to Southwest Florida in 1973. Since almost the day he arrived, Bill has been
        involved as a volunteer and leader in our community, leaving a trail of successes.
        Bill is married to his wife, Cheryl, for 30 years and is a father to three adult children:
        Kristen, a school administrator; Christopher, a Lieutenant, Naval Aviator; and Jonathan, a
        software engineer. Bill and Cheryl attend St. Elizabeth Seton Catholic Church in Naples.
        Bill has spent the majority of his professional career in real estate. In 1996, he founded and
        grew a highly successful small brokerage, which not only supported his family but also
        enabled him to actively contribute to his community. Over the years, Bill has served on the
        boards of numerous local and nonprofit organizations, and he continues to hold positions
        on several local and regional boards today.
        </div>
        <h3>Community &amp; Civic Involvement</h3>
        <div className='contentSection'>
          <div>
              <ul>
                <li>President – Naples Area Board of Realtors</li>
                <li>President – Golden Gate Civic Association</li>
                <li>President – Marco Island Jaycees</li>
                <li>Community Development Vice President – Florida Jaycees</li>
                <li>Chair – Alligator District, Boy Scouts of America</li>
                <li>Chair – Florida Realtors Political Action Committee (2019)</li>
                <li>County Co-Chair – Marco Rubio for US Senate (2010, 2016 &amp; 2022)</li>
                <li>Chair – Collier County Youth for Reagan</li>
                <li>Leadership Collier Class of 2001</li>
                <li>Former Board of Directors – Greater Naples Chamber of Commerce</li>
                <li>Past Member – Collier County Republican Executive Committee</li>
                <li>Past Member – Collier County Young Republicans</li>
                <li>Collier County Schools SAC Committees</li>
                <li>Administrative Vice President Florida CCIM</li>
                <li>Chair – Issues Mobilization – Florida Realtors</li>
                <li>Board Member – Naples Better Government</li>
                <li>Federal Political Coordinator (FPC) – NAR</li>
                <li>Chair/Vice Chair – Collier County Advisory Boards</li>
                <li>Chair – Commercial Alliance Committee – Florida Realtors</li>
                <li>Key Contact FL Legislature – Florida Realtors</li>
              </ul>     
            </div>
          <div>
            <img src="/rubio_2010_photo.jpeg" alt="Bill Poteet at a Marco Rubio Campaign Event." />
            <div className='contentImageSubtext'>Co-Chairs for Marco Rubio's Senatorial Campaign.</div>
            <img src="/DSC_0022_edited.jpg" alt="Bill Poteet at the Florida Capitol" />
            <div className='contentImageSubtext'>Bill Poteet at the Florida Capitol.</div>
          </div>
        </div>

        <h3>Awards and Recognitions</h3>
        <div className='contentSection'>
            <div>
            <ul>
              <li>2008 Golden Gate Citizen of the Year – Collier Citizen Newspaper</li>
              <li>JCI Senatorship – United States Jaycees</li>
              <li>Realtor of the Year – Naples Area Board of Realtors</li>
              <li>Collier County Advisory Board Member Award</li>
              <li>Silver Beaver – Southwest Florida Council, Boy Scouts of America</li>
              <li>Naples Area Board of Realtors Hall of Fame Award</li>
              <li>2016 Florida Realtor Commercial Achievement Award</li>
              <li>District Award of Merit – Alligator District BSA</li>
              <li>Ad Miller Award – Naples Area Board of Realtors</li>
              <li>RPAC Hall of Fame – NAR</li>
            </ul>
            </div>
            <div>
              <img src="/rick_scott_poteet.JPG" alt="Bill Poteet in a meeting with Governor Rick Scott." />
              <div className='contentImageSubtext'>Bill Poteet in a meeting with Governor Rick Scott.</div>
            </div>
        </div>

        <div className='contentSection'>
          <div>
            Prior to moving to Southwest Florida, Bill attended the University of Missouri. He holds an
            Arts &amp; Science Degree in General Studies. He earned the Certified Commercial Investment
            Member (CCIM) designation and the Certified Leasing Specialist (CLS) designation from the
            International Council of Shopping Centers.
            <br/><br/>
            
            Bill is not looking to climb a political ladder. He has the lifelong leadership, conservative
            values, and business experience we need to represent us in Tallahassee.
          </div>
          <div>
            <img src="/Family - Chris Wings Ceremony.jpg" alt="Bill Poteet with his family." />
            <div className='contentImageSubtext'>Bill Poteet with his family.</div>
          </div>
        </div>
          <div className='imageContainerGroup'>
            <div>
              <img src="/jr deputies_edited.jpg" alt="Bill Poteet with the Junior Deputies of Collier County." />
                <div>Bill Poteet with the Junior Deputies of Collier County.</div>
            </div>
            <div>
              <img src="/RPOF 31_edited.jpg" alt="Bill Poteet with Governor Ron DeSantis." />
              <div>Bill Poteet with Governor Ron DeSantis.</div>
            </div>
             <div>
              <img src="/IMG_6960_edited.jpg" alt="Bill Poteet with Congressman Mario Díaz-Balart." />
              <div>Bill Poteet with Congressman Mario Díaz-Balart.</div>
            </div>
            <div>
              <img src="/IMG_6958_edited.jpg" alt="Bill Poteet with Congressman Byron Donalds." />
              <div>Bill Poteet with Congressman Byron Donalds.</div>
            </div>
          </div>
        <div className='imageContainer'>
            <img src="/group_photo_with_trump.jpg" alt="Bill Poteet with President Donald J. Trump." />
            <div>Bill Poteet with President Donald J. Trump.</div>
        </div>
      </div>

      <iframe
        title='Stay Updated'
        src="https://docs.google.com/forms/d/e/1FAIpQLSdDhG6YCqYRNi3Z_RqEn3yjPbqri76JNhQi5Hv4UxZ4b0ctjw/viewform?embedded=true"
        width="640"
        height="1350"
        className='iframe-contact'
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
      >
        Loading…
      </iframe>


      {/* <div>
        <a href="/privacy-policy">Privacy Policy</a> | <a href="/terms-and-conditions">Terms & Conditions</a>
      </div> */}

      <div className="donate-link">
        <a href="https://secure.anedot.com/bill-poteet-for-state-representative-dist-82/donate">DONATE</a>
      </div>
      <footer className="footer">
        <div>
          <p>Follow us:</p>
          <div className="social-media">
            <a href="https://www.facebook.com/profile.php?id=61576998381130" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://x.com/PHouse82" target="_blank" rel="noopener noreferrer">
              <FaXTwitter />
            </a>
            <a href="https://truthsocial.com/@Poteet4House82" target="_blank" rel="noopener noreferrer">
              <TruthSocialIcon/>
            </a>
          </div>
        </div>

        <div>Paid for by Bill Poteet, Republican for Florida House District 82</div>
        <div>3200 Bailey Lane, Ste 199, Naples, FL 34105</div>
      </footer>
    </div>
  );
};

export default MainContent;
